import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { TokenService } from './token.service';

@Injectable()
export class ApiService {
  attempts = 0;

  constructor(
    private http: HttpClient,
    private tokenService: TokenService
  ) {}

  private setHeaders(params?): HttpHeaders {
    const headersConfig = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };
    if (params) {
      headersConfig['params'] = params;
    }
    if (this.tokenService.getToken()) {
      headersConfig['Authorization'] = `Bearer ${this.tokenService.getToken().token}`;
    }
    return new HttpHeaders(headersConfig);
  }

  private formatErrors(error: any) {
    return Observable.throw(error.error);
  }

  get(path: string, params?: object): Observable<any> {
    let header: any = {
      headers: this.setHeaders()
    };
    if (params) {
      header.params = params;
    }
    return this.http.get(`${environment.api_url}${path}`, header)
    .catch((error: any) => this.formatErrors(error))
    .map((res) => res);
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http.put(
      `${environment.api_url}${path}`,
      JSON.stringify(body),
      { headers: this.setHeaders() }
    )
    .catch(this.formatErrors)
    .map((res) => res);
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.http.post(
      `${environment.api_url}${path}`,
      JSON.stringify(body),
      {headers: this.setHeaders(), responseType: 'text'}
    )
    .catch(this.formatErrors)
    .map((res) => {
      try {
        return res;
      } catch (e) {
        return res;
      }
    });
  }

  delete(path): Observable<any> {
    return this.http.delete(
      `${environment.api_url}${path}`,
      { headers: this.setHeaders() }
    )
    .catch(this.formatErrors)
    .map((res) => res);
  }

  postPicasso(path: string, body: Object = {}): Observable<any> {
    return this.http.post(
      `${environment.picasso_url}${path}`,
      JSON.stringify(body),
      { headers: this.setHeaders() }
    )
    .catch(this.formatErrors)
    .map((res) => {
      return res;
    });
  }

  getDaikoku(path: string, params?: object): Observable<any> {
    return this.http.get(`${environment.daikoku_url}${path}`, {
      headers: this.setHeaders(params)
    })
    .catch(this.formatErrors)
    .map((res) => res);
  }

  postDaikoku(path: string, body: Object = {}): Observable<any> {
    return this.http.post(
      `${environment.daikoku_url}${path}`,
      JSON.stringify(body),
      { headers: this.setHeaders() }
    )
    .catch(this.formatErrors)
    .map((res) => res);
  }

  deleteDaikoku(path): Observable<any> {
    return this.http.delete(
      `${environment.daikoku_url}${path}`,
      { headers: this.setHeaders() }
    )
    .catch(this.formatErrors)
    .map((res) => res);
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/services/api.service.ts